import { gql } from "@apollo/client";

export const BATCH_UPLOAD_PENDING_TICKETS = gql`
  mutation batchUploadPendingTickets($input: [batchUploadPendingTicketsInput]!) {
    batchUploadPendingTickets(input: $input) {
      _id
    }
  }
`;

export const RUN_AUTOMATION = gql`
  mutation runTicketAutomation {
    runTicketAutomation {
      totalTickets
      createdTickets {
        ticket_id
        asset_serial
        message
      }
      failedTickets {
        ticket_id
        asset_serial
        message
      }
    }
  }
`;